import React, { useEffect, useState } from 'react'
import axios from '../axios';
import HeaderSecond from '../HeaderSecond'
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import NoItemAdded from '../img/other/no-item.png'
import { Calculation } from './Calculation';
import couponDiscount from '../img/other/discount.png'
import { ToastContainer, toast } from 'react-toastify';
import failedImg from '../img/other/failed.gif';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import AppliedCouponAlert from "../Event/AppliedCouponAlert";

const RegisterNow = () => {

    const navigate = useNavigate();
    const [ApiCall, setApiCall] = useState(true);
    const [AllTickets, setAllTickets] = useState([]);
    const [TotalPrice, setTotalPrice] = useState(0);
    const [FinalTotalPrice, setFinalTotalPrice] = useState(0);
    const [TotalAttendee, setTotalAttendee] = useState(0);
    const [TotalDiscount, setTotalDiscount] = useState(0);

    const [EventData, setEventData] = useState('')
    const location = useLocation();
    //----------- New added
    // const { EventId } = useParams();
    const { state } = useLocation();
    const { EventId: paramEventId } = useParams();
    const EventId = state?.eventId || paramEventId;

    const [UtmCampaign, setUtmCampaign] = useState("")

    const [OrgGstPercentage, setOrgGstPercentage] = useState('');
    const [TicketYtcrBasePrice, setTicketYtcrBasePrice] = useState('');
    const [YtcrFeePercentage, setYtcrFeePercentage] = useState('');
    const [PlatformFeePercentage, setPlatformFeePercentage] = useState('');
    const [PaymentGatewayFeePercentage, setPaymentGatewayFeePercentage] = useState('');
    const [PaymentGatewayGstPercentage, setPaymentGatewayGstPercentage] = useState('');
    const [CollectGst, setCollectGst] = useState('');
    const [PriceTaxesStatus, setPriceTaxesStatus] = useState('');

    const [CalTicketPrice, setCalTicketPrice] = useState(false);
    const [ClickOnTicketId, setClickOnTicketId] = useState(0);

    const [TicketIds, setTicketIds] = useState("");
    const [Coupons, setCoupons] = useState([]);
    const [CouponApiCall, setCouponApiCall] = useState(false);
    const [appliedCoupons, setAppliedCoupons] = useState([]);
    const [Calculate, setCalculate] = useState(false);
    const [CounterCalculate, setCounterCalculate] = useState(false);
    const [CartTicketIds] = useState([])

    const [LoaderFlag, setLoaderFlag] = useState(false);
    const [CouponCode, setCouponCode] = useState("");
    const [RemoveCoupon, setRemoveCoupon] = useState(false);
    const [PaymentFailurePopup, setPaymentFailurePopup] = useState(false);
    const [RaceCategoryCharges, setRaceCategoryCharges] = useState([]);
    const [NewCouponData, setNewCouponData] = useState([]);
    const [TempCouponData, setTempCouponData] = useState([]);
    const [EventRegiStatus, setEventRegiStatus] = useState(2); // 1 - Single / 2 - Multiple Registreation

    const [TotalBookingRegistration, setTotalBookingRegistration] = useState(0);
    const [OverallLimit, setOverallLimit] = useState(0);

    let [TempCount, setTempCount] = useState(0);
    const [BookingLimitExceed, setBookingLimitExceed] = useState(0);
    const [SingleTicketId1, setSingleTicketId1] = useState(0);
    const [EventRedirectionName, setEventRedirectionName] = useState('');
    const [AppliedCouponPopup, setAppliedCouponPopup] = useState(false);
    const [DisplayCouponCode, setDisplayCouponCode] = useState('');
    const [CouponDiscountPrice, setCouponDiscountPrice] = useState(0);

    const BookTicketEventId = localStorage.getItem('BookTicketEventId');
    const { payment_status } = useParams();

    localStorage.removeItem("booking_pay_id");
    const [Login, setLogin] = useState(false);

    const AllowGuestLogin = localStorage.getItem("AllowGuestLogin") ? localStorage.getItem("AllowGuestLogin") : 0;
    const GuestLoginEventId = localStorage.getItem("GuestLoginEventId") ? localStorage.getItem("GuestLoginEventId") : 0;

    const handleOnfocus = () => {
        navigate(`/register_now/${EventId}`);

        // Delay scroll after navigation — wait for page to render
        setTimeout(() => {
            const element = document.getElementById('navigateHere');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                element.focus({ preventScroll: true });
            }
        }, 100); // Adjust delay as needed
    };

    useEffect(() => {
        if (location.hash) {
            const targetId = location.hash.replace('#', '');
            const element = document.getElementById(targetId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll
                element.focus({ preventScroll: true }); // Focus if needed
            }
        }
    }, [location]);

    useEffect(() => {
        const RacesToken = localStorage.getItem("RacesToken") ? localStorage.getItem("RacesToken") : "";
        // console.log(RacesToken);
        if (RacesToken && RacesToken !== '') {
            setLogin(false);
        } else {
            setLogin(true);
        }
        localStorage.removeItem('redirect_url_flag');

        //------- Guest login check event
        if (AllowGuestLogin == 1 && (EventId != GuestLoginEventId)) {
            navigate('/')
        }
    }, []);

    useEffect(() => {
        if (payment_status === 'failure') {
            setPaymentFailurePopup(true);
        }
        else {
            //   navigate('/events')
            setPaymentFailurePopup(false);
        }
    }, [payment_status]);

    // user link hit
    useEffect(() => {
        if (location.state) {
            if (location.state.utm_campaign) {
                // console.log(location.state.utm_campaign);
                setUtmCampaign(location.state.utm_campaign)  // set on location url
            }
        }
    }, [location.state])

    // GET TICKET API
    useEffect(() => {
        if (ApiCall) {
            setLoaderFlag(true);
            axios.post("get_event_ticket", {
                "event_id": EventId ? EventId : BookTicketEventId
            })
                .then((response) => {
                    // console.log(response.data.data.EventData[0]);
                    if (response.status === 200 && response.data.data.EventData && response.data.data.EventData.length > 0) {
                        setApiCall(false)
                        setAllTickets(response.data.data.event_tickets);
                        setEventData(response.data.data.EventData[0]);
                        setEventRegiStatus(response.data.data.EventData[0].event_registration_status);
                        setRaceCategoryCharges(response.data.data.race_category_charges_details);
                        setTotalBookingRegistration(response.data.data.EventData ? response.data.data.EventData[0].total_booking_registration : 0);
                        setOverallLimit(response.data.data.EventData ? response.data.data.EventData[0].overall_limit : 0);
                        // setOrgGstPercentage(response.data.data.OrgGstPercentage)
                        // setTicketYtcrBasePrice(response.data.data.TicketYtcrBasePrice)
                        // setYtcrFeePercentage(response.data.data.YTCR_FEE_PERCENT)
                        // // setPlatformFeePercentage(response.data.data.PLATFORM_FEE_PERCENT)
                        // setPaymentGatewayFeePercentage(response.data.data.PAYMENT_GATEWAY_FEE_PERCENT)
                        // setPaymentGatewayGstPercentage(response.data.data.PAYMENT_GATEWAY_GST_PERCENT)

                        // Calculation(TicketArr[index], OrgGstPercentage, TicketYtcrBasePrice, YTCR_FEE_PERCENT, PAYMENT_GATEWAY_FEE_PERCENT, PAYMENT_GATEWAY_GST_PERCENT, CollectGst, PriceTaxesStatus);

                        setCollectGst(response.data.data.CollectGst);
                        setPriceTaxesStatus(response.data.data.PriceTaxesStatus);
                        setEventRedirectionName(response.data.data.EventData[0].name);

                        if (response.data.data.event_tickets !== "") {
                            // console.log(response.data.data.event_tickets)
                            // const keysArray = response.data.data.event_tickets.map(obj => obj.id);
                            let eventTickets = response.data.data.event_tickets;

                            const keysArray = eventTickets
                                .filter(ticket => ticket.ticket_status === 1)
                                .map(ticket => ticket.id);
                            // console.log(keysArray);
                            setTicketIds(keysArray);
                            setCouponApiCall(true);
                        }

                        setLoaderFlag(false)
                    } else {
                        toast.error("Something went wrong");

                        const timer = setTimeout(() => {
                            navigate('/');
                        }, 6000); // Adjust the delay as needed (in milliseconds)
                        return () => clearTimeout(timer);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [ApiCall, EventId])

    //console.log(AllTickets);
    // GET COUPONS API
    useEffect(() => {
        if ((EventId !== 0 || BookTicketEventId !== 0) && TicketIds !== "" && CouponApiCall) {
            axios.post("get_coupons", {
                "event_id": EventId ? EventId : BookTicketEventId,
                "ticket_ids": TicketIds
            })
                .then((response) => {
                    // console.log(response.data.data.Coupons);
                    setCoupons(response.data.data.Coupons);
                    setCouponApiCall(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [CouponApiCall, Coupons, EventId, TicketIds, BookTicketEventId]);

    // REMOVE COUPON AMOUNT FROM CART
    const HandleRemoveCouponAmount = (coupon) => {
        // console.log(coupon);
        AllTickets.forEach(element => {
            // console.log(element);
            // Subtract appliedCouponAmount if set
            if (element["appliedCouponAmount"] && element["appliedCouponId"] === coupon.id) {
                // Remove appliedCouponAmount and appliedCouponCode from the element
                delete element["appliedCouponAmount"];
                delete element["appliedCouponCode"];
                delete element["appliedCouponId"];
                delete element["appliedCouponTicketCount"];
            } else {

            }
        });
        setCalTicketPrice(true);
        setCouponApiCall(true);
    }

    // ADD COUPONS IN CART
    const handleApplyCoupon = (coupon) => {
        // console.log(coupon);

        const email = localStorage.getItem("EMAIL");
        let oneTimeApplied1 = false;

        if (coupon.user_email_address) {
            const couponEmails = coupon.user_email_address.split(',').map(e => e.trim());
            if (!couponEmails.includes(email)) {
                toast.error("Coupon is not applicable for this user.");
                return;
            }
        }

        //--------- previous coupon data remove
        let tot_appliedAmount = 0;
        // if (appliedCoupons.length > 0) {
        //     handleRemoveCoupon(appliedCoupons[0]);
        // }

        // -------- if check coupon exstist or not from ticket
        const ticketIds = coupon.ticket_details.split(',');
        const isTicketInCart = ticketIds.some(ticketId => CartTicketIds.includes(parseInt(ticketId)));
        if (!isTicketInCart) {
            toast.error("This coupon is not applicable for the selected tickets.");
            return;
        }
        let count = parseFloat(coupon.coupon_count);
        // console.log(count)
        const totalTicketsCount = sumKey(AllTickets, "count");
        // console.log(CartTicketIds);
        //  console.log(count,coupon.no_of_discount);
        CartTicketIds.forEach(ticketId => {
            let appliedAmount = 0;
            const ticket = AllTickets.find(ticket => ticket.id === parseInt(ticketId));
            setNewCouponData(coupon);
            //    console.log(ticket);
            if (ticket) {
                const ticketIdInt = parseInt(ticket.id);
                const ticketStatusInt = parseInt(ticket.ticket_status);
                if (ticketStatusInt === 1) {
                    if (!isNaN(ticketIdInt) && ticketIds.includes(ticketIdInt.toString())) {

                        count += ticket.count;

                        // console.log(parseFloat(coupon.coupon_count) , coupon.no_of_discount , count);  
                        if ((parseFloat(coupon.coupon_count) <= coupon.no_of_discount) && count <= coupon.no_of_discount) {
                            // console.log('eee');
                            // add item count (frontend) || (coupon.discount_type == 1 && !oneTimeApplied1) 
                            //PERCENTAGE
                            const ticket_price = ticket.show_early_bird === 1 ? ticket.discount_ticket_price : ticket.ticket_price;
                            if (ticket_price && !isNaN(ticket_price) && ticket_price !== 0) {
                                // Discount Percentage
                                if (coupon.discount_amt_per_type === 1) {
                                    if (coupon.discount_type == 1) { //One time use                                      
                                        appliedAmount += ((ticket_price * coupon.discount_percentage) / 100) * ticket.count;
                                        ticket.appliedCouponAmount = appliedAmount;
                                        ticket.appliedCouponCode = coupon.discount_code;
                                        ticket.appliedCouponId = coupon.id;
                                        ticket.appliedCouponTicketCount = ticket.count;

                                        coupon.coupon_count = count;

                                    } if (coupon.discount_type === 2) { //Multiple time use	
                                        appliedAmount += ((ticket_price * coupon.discount_percentage) / 100) * ticket.count;
                                        ticket.appliedCouponAmount = appliedAmount;
                                        ticket.appliedCouponCode = coupon.discount_code;
                                        ticket.appliedCouponId = coupon.id;
                                        ticket.appliedCouponTicketCount = ticket.count;
                                    }
                                }

                                // Discount Amount
                                if (coupon.discount_amt_per_type == 2) {
                                    // console.log(coupon.discount_amount);    
                                    // -------- One time use
                                    if (coupon.discount_type == 1) {
                                        appliedAmount = (parseFloat(coupon.discount_amount) * ticket.count);
                                        ticket.appliedCouponAmount = appliedAmount;
                                        ticket.appliedCouponCode = coupon.discount_code;
                                        ticket.appliedCouponId = coupon.id;
                                        ticket.appliedCouponTicketCount = ticket.count;
                                    } if (coupon.discount_type == 2) { // Multiple time
                                        appliedAmount = (parseFloat(coupon.discount_amount) * ticket.count);
                                        ticket.appliedCouponAmount = appliedAmount;
                                        ticket.appliedCouponCode = coupon.discount_code;
                                        ticket.appliedCouponId = coupon.id;
                                        ticket.appliedCouponTicketCount = ticket.count;
                                    }
                                }

                                tot_appliedAmount += appliedAmount;
                                coupon.coupon_count = count;
                                oneTimeApplied1 = true;
                            }
                        } else {
                            // toast.error("This coupon code is out of stock.");
                            const remaining = coupon.no_of_discount - (count - ticket.count);
                            if ((CartTicketIds.length === 1) && count > coupon.no_of_discount) {
                                toast.error(`This coupon code has reached its usage limit. Only ${remaining} coupon's are available.`);
                                return;
                            } else {
                                toast.error(`This coupon code has reached its usage limit for ${ticket.display_ticket_name}. Only ${remaining} coupon's are available.`);
                            }
                        }

                        // console.log(tot_appliedAmount,ticket.count);
                        // Set the new coupon with the calculated applied amount
                        coupon.applied_amount = tot_appliedAmount; // * ticket.count
                        //  console.log(coupon);
                        setAppliedCoupons([coupon]);
                        setCalculate(true);
                        setCalTicketPrice(true);
                    }
                } else {
                    // if(ticketStatusInt === 2)
                    // toast.success("This ticket is free, so coupons cannot be applied.")
                }
            }
        });

        if (oneTimeApplied1) {
            // toast.success("Coupon applied successfully!");
            setCouponDiscountPrice(coupon.applied_amount);
            setDisplayCouponCode(coupon.discount_code);
            setAppliedCouponPopup(true);
            oneTimeApplied1 = false;
        }
    };
    // console.log(NewCouponData, AllTickets);
    const ApplyCouponCode = () => {
        if (CouponCode !== "") {
            // get all coupons public and non-public
            axios.post("get_coupons", {
                "event_id": EventId ? EventId : BookTicketEventId,
                "ticket_ids": TicketIds,
                "show_public": 1
            })
                .then((response) => {
                    if (response.data.data.Coupons.length > 0) {
                        // const coupon = response.data.data.Coupons.find(coupon => coupon.discount_code === CouponCode);
                        const coupon = response.data.data.Coupons.find(
                        cup => cup.discount_code?.toLowerCase() === CouponCode?.toLowerCase()
                        );
                        //console.log(coupon)
                        if (coupon) {
                            handleApplyCoupon(coupon);
                            setTempCouponData(coupon);
                            setRemoveCoupon(true);
                        } else {
                            toast.error("Invalid Coupon Code");
                        }
                    } else {
                        toast.error("Invalid Coupon Code");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }
    // console.log(Coupons)

    // CALCULATE FINALAMOUNT = TOTALPRICE - COUPON PRICE(ADD COUPON)
    useEffect(() => {
        if (Calculate) {
            // console.log(Calculate);
            const final_amt = isNaN(parseFloat(FinalTotalPrice)) ? 0.00 : parseFloat(FinalTotalPrice);
            //    console.log(final_amt,appliedCoupons);
            const totalAmount = final_amt - appliedCoupons.reduce((acc, item) => {

                const itemValue = isNaN(parseFloat(item.applied_amount)) ? 0.00 : parseFloat(item.applied_amount);

                //  console.log(item.applied_amount,itemValue);

                return acc + itemValue;
            }, 0);
            //    console.log(totalAmount);
            setFinalTotalPrice(totalAmount.toFixed(2));
            setCalculate(false)
        }
    }, [Calculate, FinalTotalPrice, appliedCoupons, setCalculate]);
    // console.log(FinalTotalPrice);
    // REMOVE COUPON FROM CART
    // console.log(TempCouponData);
    const handleRemoveCoupon = (coupon) => {
        // console.log(coupon);
        HandleRemoveCouponAmount(coupon)
        setAppliedCoupons(prevCoupons => prevCoupons.filter(item => item.id !== coupon.id));
        toast.error("Coupon removed successfully!");
    };

    const isCouponApplied = (coupon_id) => {
        // console.log(coupon_id);
        return appliedCoupons.some(item => item.id === coupon_id);
    };
    //console.log(appliedCoupons);
    // console.log(OrgGstPercentage, TicketYtcrBasePrice, YtcrFeePercentage, PaymentGatewayFeePercentage, PaymentGatewayGstPercentage, CollectGst, PriceTaxesStatus);

    // console.log(OverallLimit,BookingLimitExceed);

    // console.log(AllTickets);
    const TicketCount = (index, type) => {

        // console.log(index);
        const TicketArr = [...AllTickets];
        const single_ticket_id = TicketArr[index]["id"];
        setSingleTicketId1(single_ticket_id);

        if (type === 'add') { //------------------------------------ Add items

            //----------- new added
            if (EventRegiStatus === 1) {
                for (let item of TicketArr) {
                    item.single_ticket_flag = 1; // Add or update the key-value pair
                }
            }

            // console.log(TicketArr[index]["single_ticket_flag"]);
            //---------------- event registration for (single and multiple) 
            if (TicketArr[index]["single_ticket_flag"] && TicketArr[index]["single_ticket_flag"] === 1) {

                for (let i = 0; i < TicketArr.length; i++) {
                    // TicketArr[i].single_ticket_flag = 0; // Add or update the key-value pair

                    //------- overall limit and total registration count
                    if (OverallLimit !== 0) {

                        if (TicketArr[index]["single_ticket_flag"] === 1 && TicketArr[index]["limit_exceed_flag"] === 0) {
                            //   console.log(BookingLimitExceed,OverallLimit);
                            //-- new if cond added for ticket wise limit exceed
                            //   console.log(TicketArr[index]["total_quantity"] , parseInt(TicketArr[index]["TotalBookedTickets"]));
                            if (parseInt(TicketArr[index]["total_quantity"]) > parseInt(TicketArr[index]["TotalBookedTickets"])) {

                                if (TicketArr[index] !== index) {
                                    // console.log(TicketArr[index]["count"]);
                                    TicketArr[i]["count"] -= TicketArr[i]["count"] > 1 ? TicketArr[i]["count"] : 1;
                                    TicketArr[index]["TotalBookedTickets"] -= TicketArr[index]["count"] > 1 ? TicketArr[index]["count"] : 1;

                                    delete TicketArr[i]["appliedCouponAmount"];
                                    delete TicketArr[i]["appliedCouponCode"];
                                    delete TicketArr[i]["appliedCouponId"];
                                    delete TicketArr[i]["appliedCouponTicketCount"];

                                    TicketArr[i]["Error"] = "";
                                    if (TicketArr[i]["count"] < TicketArr[i]["min_booking"]) {

                                        TicketArr[i]["count"] = 0;

                                        // remove ID from CartTicketIds
                                        const ticketIdIndex = CartTicketIds.indexOf(TicketArr[i]["id"]);
                                        if (ticketIdIndex > -1) {
                                            CartTicketIds.splice(ticketIdIndex, 1);
                                        }

                                        //----------------------
                                        TicketArr[index]["count"] = TicketArr[index]["min_booking"];
                                        Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);

                                        setCalTicketPrice(true);
                                        // add ID from CartTicketIds
                                        if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                            CartTicketIds.push(TicketArr[index]["id"]);
                                        }

                                    }
                                }
                            } else {
                                TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                            }

                        } else if (TicketArr[index]["limit_exceed_flag"] === 0 && (parseInt(BookingLimitExceed) === 0 || parseInt(BookingLimitExceed) < parseInt(OverallLimit))) {

                            if (TicketArr[index] !== index) {

                                TicketArr[i]["count"] -= 1;
                                TicketArr[i]["Error"] = "";
                                if (TicketArr[i]["count"] < TicketArr[i]["min_booking"]) {

                                    TicketArr[i]["count"] = 0;

                                    // remove ID from CartTicketIds
                                    const ticketIdIndex = CartTicketIds.indexOf(TicketArr[i]["id"]);
                                    if (ticketIdIndex > -1) {
                                        CartTicketIds.splice(ticketIdIndex, 1);
                                    }

                                    //----------------------
                                    TicketArr[index]["count"] = TicketArr[index]["min_booking"];
                                    Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);

                                    setCalTicketPrice(true);
                                    // add ID from CartTicketIds
                                    if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                        CartTicketIds.push(TicketArr[index]["id"]);
                                    }
                                    TicketArr[i]["Error"] = '';
                                }

                                //--------- temp count store
                                // console.log(TicketArr[index]["count"]);
                                TempCount += 1; // TicketArr[index]["count"];
                                setTempCount(TempCount);
                            }
                        } else {
                            TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                        }

                    } else {

                        //------- overall limit and total registration count
                        if (OverallLimit !== 0) {

                            if (TicketArr[index]["limit_exceed_flag"] === 0 && (parseInt(BookingLimitExceed) === 0 || parseInt(BookingLimitExceed) < parseInt(OverallLimit))) {
                                TicketArr[index]["count"] = TicketArr[index]["min_booking"];

                                //--------- temp count store
                                TempCount += 1; // TicketArr[index]["count"];
                                setTempCount(TempCount);

                                Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                                setCalTicketPrice(true);
                                // add ID from CartTicketIds
                                if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                    CartTicketIds.push(TicketArr[index]["id"]);
                                }
                                TicketArr[index]["Error"] = '';

                            } else {
                                TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                            }

                        } else {

                            if (TicketArr[index]["single_ticket_flag"] && TicketArr[index]["single_ticket_flag"] === 1) {
                                if (TicketArr[i] !== index) {

                                    TicketArr[i]["count"] = 0;
                                    // remove ID from CartTicketIds
                                    const ticketIdIndex = CartTicketIds.indexOf(TicketArr[i]["id"]);
                                    if (ticketIdIndex > -1) {
                                        CartTicketIds.splice(ticketIdIndex, 1);
                                    }
                                    TicketArr[i]["Error"] = '';
                                }

                                //---------- new added for registration limit exceed
                                if (TicketArr[index]["total_quantity"] > TicketArr[index]["TotalBookedTickets"] && (TicketArr[index]["total_quantity"] >= parseFloat(TicketArr[index]["TotalBookedTickets"] + TicketArr[index]["min_booking"]))) {

                                    TicketArr[index]["count"] = TicketArr[index]["min_booking"];
                                    Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                                    setCalTicketPrice(true);
                                    // add ID from CartTicketIds
                                    if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                        CartTicketIds.push(TicketArr[index]["id"]);
                                    }
                                    TicketArr[index]["TotalBookedTickets"] += TicketArr[index]["min_booking"];
                                } else {
                                    TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                                }
                                // TicketArr[index]["Error"] = 'Single category allowed';
                            } else {

                                if (TicketArr[index] !== index) {

                                    TicketArr[i]["count"] -= 1;
                                    TicketArr[i]["Error"] = "";
                                    if (TicketArr[i]["count"] < TicketArr[i]["min_booking"]) {

                                        TicketArr[i]["count"] = 0;

                                        // remove ID from CartTicketIds
                                        const ticketIdIndex = CartTicketIds.indexOf(TicketArr[i]["id"]);
                                        if (ticketIdIndex > -1) {
                                            CartTicketIds.splice(ticketIdIndex, 1);
                                        }

                                        //----------------------
                                        TicketArr[index]["count"] = TicketArr[index]["min_booking"];
                                        Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);

                                        setCalTicketPrice(true);
                                        // add ID from CartTicketIds
                                        if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                            CartTicketIds.push(TicketArr[index]["id"]);
                                        }

                                    }
                                }
                            }

                        } //-------- else end

                    }

                }

            } else {
                //    console.log(TicketArr[index]["single_ticket_flag"]);
                //console.log(TicketArr[index]["total_quantity"] , parseInt(TicketArr[index]["TotalBookedTickets"]));
                if (TicketArr[index]["single_ticket_flag"] === 1 && TicketArr[index]["limit_exceed_flag"] === 0) {
                    //   console.log('ss');
                    if (parseInt(TicketArr[index]["total_quantity"]) > parseInt(TicketArr[index]["TotalBookedTickets"])) {
                        if (TicketArr[index] !== index) {
                            for (let i = 0; i < TicketArr.length; i++) {
                                TicketArr[i]["count"] -= TicketArr[i]["count"];
                                TicketArr[index]["TotalBookedTickets"] -= TicketArr[index]["count"] > 1 ? TicketArr[index]["count"] : 1;
                            }
                        }
                    }
                } else {
                    // console.log('ss');
                    //----------
                    if (TicketArr[index]["limit_exceed_flag"] === 1) {
                        TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                    } else {
                        // console.log(BookingLimitExceed, OverallLimit)
                        if (OverallLimit !== 0 && (parseInt(BookingLimitExceed) > parseInt(OverallLimit))) {
                            TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                        } else {

                            // console.log(TicketArr[index]["total_quantity"], TicketArr[index]["TotalBookedTickets"], TicketArr[index]["min_booking"]);
                            //---------- new added for registration limit exceed
                            if (TicketArr[index]["total_quantity"] > TicketArr[index]["TotalBookedTickets"] && (TicketArr[index]["total_quantity"] >= parseFloat(TicketArr[index]["TotalBookedTickets"] + TicketArr[index]["min_booking"]))) {

                                TicketArr[index]["count"] = TicketArr[index]["min_booking"];
                                Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                                setCalTicketPrice(true);

                                // add ID from CartTicketIds
                                if (!CartTicketIds.includes(TicketArr[index]["id"])) {
                                    CartTicketIds.push(TicketArr[index]["id"]);
                                }

                                // TicketArr[index]["TotalBookedTickets"] += TicketArr[index]["min_booking"];
                                TicketArr[index]["TotalBookedTickets"] += 1;

                            } else {
                                TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                            }
                        }
                    }
                    //console.log(TicketArr[index]["TotalBookedTickets"]);

                    TempCount += 1; // TicketArr[index]["count"];
                    setTempCount(TempCount);
                }
            }

        }
        else if (type === 'plus') { //------------------------------------ (+) items
            //console.log('ss');

            if (TicketArr[index]["count"] < TicketArr[index]["max_booking"]) {
                // console.log('aa');
                if (OverallLimit === 0) {

                    // console.log(TicketArr[index]["total_quantity"], TicketArr[index]["TotalBookedTickets"]);
                    //---------- new added for registration limit exceed
                    if (TicketArr[index]["total_quantity"] > TicketArr[index]["TotalBookedTickets"]) {
                        TicketArr[index]["count"] += 1;
                        TicketArr[index]["Error"] = "";

                        Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                        setCalTicketPrice(true);
                        TicketArr[index]["TotalBookedTickets"] += 1;
                    } else {
                        TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                    }

                } else if (TicketArr[index]["limit_exceed_flag"] === 0 && (parseInt(BookingLimitExceed) === 0 || parseInt(BookingLimitExceed) < parseInt(OverallLimit))) {
                    // console.log(BookingLimitExceed);
                    //---------- new added for registration limit exceed
                    //   console.log(TicketArr[index]["total_quantity"],TicketArr[index]["TotalBookedTickets"] );
                    if (TicketArr[index]["total_quantity"] > TicketArr[index]["TotalBookedTickets"]) {

                        TicketArr[index]["count"] += 1;
                        TicketArr[index]["Error"] = "";

                        Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                        setCalTicketPrice(true);
                        //    console.log(TicketArr[index]["count"]);
                        //--------- temp count store
                        TempCount += 1; // (TicketArr[index]["count"]); //- TempCount
                        setTempCount(TempCount);

                        TicketArr[index]["TotalBookedTickets"] += 1;

                    } else {
                        TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                    }

                } else {
                    TicketArr[index]["Error"] = 'Maximum booking Limit Exceed.';
                }

            }
            else {
                TicketArr[index]["Error"] = "Maximum " + TicketArr[index]["max_booking"] + " ticket allowed";
            }
            // }

        } else {  //------------------------------------ remove items

            if (TicketArr[index]["count"] !== 0) {


                TicketArr[index]["count"] -= 1;
                TicketArr[index]["Error"] = "";
                if (TicketArr[index]["count"] < TicketArr[index]["min_booking"]) {
                    TicketArr[index]["count"] = 0;

                    // remove ID from CartTicketIds
                    const ticketIdIndex = CartTicketIds.indexOf(TicketArr[index]["id"]);
                    if (ticketIdIndex > -1) {
                        CartTicketIds.splice(ticketIdIndex, 1);
                    }
                    // console.log('sss');
                    //--------- temp count store
                    TempCount -= TicketArr[index]["min_booking"];
                    setTempCount(TempCount);
                    TicketArr[index]["Error"] = '';

                    //---------- new added for registration limit exceed
                    TicketArr[index]["TotalBookedTickets"] -= TicketArr[index]["min_booking"];

                } else {

                    //---------- new added for registration limit exceed
                    TicketArr[index]["TotalBookedTickets"] -= 1;

                    //--------- temp count store
                    TempCount -= 1; // TicketArr[index]["count"];
                    setTempCount(TempCount);
                    TicketArr[index]["Error"] = '';
                }

                for (let i = 0; i < TicketArr.length; i++) {
                    TicketArr[i]["Error"] = "";
                }

                //----------- new added
                for (let item of TicketArr) {
                    item.single_ticket_flag = 0; // Add or update the key-value pair
                }
                //------------ New added for the remove ticket count calculation
                Calculation(TicketArr[index], CollectGst, PriceTaxesStatus, '', RaceCategoryCharges);
                setCalTicketPrice(true);
            }
        }
        // console.log(TicketArr);
        setCounterCalculate(true);
        setAllTickets(TicketArr);
    }

    useEffect(() => {
        //    console.log(TempCount);
        const BookingTotal = (parseInt(TotalBookingRegistration) + parseInt(TempCount));
        setBookingLimitExceed(BookingTotal);
    }, [TempCount]);

    // console.log(BookingLimitExceed)

    // CALCULATE TICKET PRICE WITH EARLY BIRD
    //--------- add button click on all and multiple ticket wise amount adding (early bird discount included)
    useEffect(() => {
        if (AllTickets.length > 0 && CounterCalculate) {
            // console.log("first")
            let total_discount = 0;
            let total = 0;
            let total_attendee = 0;
            let total_amt = 0;

            const currentTimeStamp = Math.floor(Date.now() / 1000); //In seconds hence / 1000
            // console.log(AllTickets);
            AllTickets.forEach(element => {
                // console.log(element['count'],element["ticket_price"])
                let discount = 0;
                if (element['count'] !== 0) {

                    if (element["ticket_status"] === 1) {
                        total = (element['count'] * element["ticket_price"]);
                        total_amt += total;
                        // console.log(total,element['count'],element["ticket_price"])
                        // console.log(element["id"],total)
                        // CALCULATE DISCOUNT ON TOTAL PRICE
                        if (element['early_bird'] === 1) {
                            if (element['TotalBookedTickets'] <= element['no_of_tickets']) {
                                if (element['start_time'] !== "" && element['end_time'] !== "") {
                                    if (currentTimeStamp >= element['start_time'] && element['end_time'] >= currentTimeStamp) {
                                        //console.log(total,element['discount_value']);
                                        // console.log(currentTimeStamp,element['start_time'],element['end_time']);
                                        if (element['discount'] === 1) { //percentage
                                            discount = total * (element['discount_value'] / 100);
                                        } else if (element['discount'] === 2) { //amount
                                            discount = element['count'] * element['discount_value'];
                                        }
                                    }
                                } else {
                                    if (element['discount'] === 1) { //percentage
                                        discount = total * (element['discount_value'] / 100);
                                    } else if (element['discount'] === 2) { //amount
                                        discount = element['count'] * element['discount_value'];
                                    }
                                }
                            }
                            total_amt -= discount; // count * discount (2*165 = 330)
                            // console.log(discount);
                        }
                        total_discount += discount;
                    }
                    total_attendee += element['count'];

                }
                element["ticket_discount"] = discount / element["count"];
                // }
            })
            // console.log(total_amt)

            //---------- New added
            // Remove appliedCouponAmount from the each ticket count is 0
            const allZero = AllTickets.every(item => item.count === 0);
            if (allZero) {
                Coupons.forEach(element => {
                    HandleRemoveCouponAmount(element)
                    setAppliedCoupons(prevCoupons => prevCoupons.filter(item => item.id !== element.id));
                });
                // console.log(Coupons);
            }

            setTotalPrice(total_amt);
            setFinalTotalPrice(total_amt)
            setTotalAttendee(total_attendee);
            // console.log(total_discount);
            setTotalDiscount(total_discount);
            setCounterCalculate(false)
            handleRemovePreviousAppliedCoupon(total_amt, AllTickets);
        }
    }, [AllTickets, CounterCalculate])
    //console.log(FinalTotalPrice);

    useEffect(() => {
        if (CalTicketPrice) {
            let total = 0;
            let coupon_total = 0;
            let totalAmount = 0;
            let totalAmount1 = 0
            let single_ticket_price = 0;
            AllTickets.forEach(element => {
                // console.log(element);
                if (element['count'] !== 0 && element['ticket_status'] === 1) {
                    // let ticket_price = element['show_early_bird'] === 1 ? element['discount_ticket_price'] : element['ticket_price']; TotalPrice
                    let ticket_price = element['show_early_bird'] === 1 ? element['discount_ticket_price'] : element['ticket_price'];
                    //    console.log(element['count'] , ticket_price);
                    single_ticket_price = (element['count'] * ticket_price);
                    // console.log(element["appliedCouponAmount"]);
                    // console.log(total,element["appliedCouponAmount"]);

                    // Subtract appliedCouponAmount if set
                    // if (element["appliedCouponAmount"]) {
                    //    //coupon_total += element["appliedCouponAmount"];
                    //     total -= element["appliedCouponAmount"];
                    // }


                    //console.log(totalAmount,total);
                    // if (element["appliedCouponAmount"]) {
                    //     total -= element["appliedCouponAmount"];
                    // }

                    //    console.log(single_ticket_price);
                    //-------------------
                    if (Coupons) {
                        for (let item of appliedCoupons) {
                            //  console.log(item);
                            const CouponTicketIds = item.ticket_details.split(',');
                            const IsCouponApplied = CouponTicketIds.includes(element["id"].toString());
                            // console.log(CouponTicketIds);
                            if (IsCouponApplied && (element["id"] === ClickOnTicketId)) {
                                if (item.discount_amt_per_type === 1) {
                                    totalAmount = (single_ticket_price * item.discount_percentage) / 100;
                                } else {
                                    totalAmount = item.discount_amount;
                                }
                                totalAmount1 += (totalAmount);
                                //    console.log(element['count'] , totalAmount, totalAmount1);
                            } else {

                                totalAmount1 = item.applied_amount ? item.applied_amount : 0;
                                //    console.log(item.applied_amount,totalAmount1);
                            }

                        }
                    }
                    //  console.log(totalAmount);
                    //    element.appliedCouponAmount += totalAmount1;

                    total += (element['count'] * ticket_price);
                    // console.log(appliedCoupons);
                    // console.log("here to calculate");
                    Calculation(element, CollectGst, PriceTaxesStatus, '', RaceCategoryCharges, 0, appliedCoupons);
                    // console.log(result);
                    setCalTicketPrice(true);
                }
            })


            total -= totalAmount1;
            //    console.log(total);
            // console.log(coupon_total);
            // setTotalPrice(total);
            setFinalTotalPrice(total);
            setCalTicketPrice(false);
        }
    }, [AllTickets, CalTicketPrice, CollectGst, OrgGstPercentage, PaymentGatewayFeePercentage, PaymentGatewayGstPercentage, PriceTaxesStatus, TicketYtcrBasePrice, YtcrFeePercentage])

    const HandleContinue = (e) => {
        // console.log(AllTickets, TotalPrice, FinalTotalPrice);
        e.preventDefault();

        if (Number(FinalTotalPrice) < 0) {
            alert("Total amount cannot be negative.");
            return;
        }

        // navigate('/ticket_registration/' + EventId, {
        navigate('/ticket_registration', {
            state: {
                eventId: EventId,
                TotalAttendee: TotalAttendee,
                AllTickets: AllTickets,
                TotalPrice: TotalPrice,
                TotalDiscount: TotalDiscount,
                EventData: EventData,
                UtmCampaign: UtmCampaign,
                FinalTotalPrice: FinalTotalPrice,
                appliedCoupons: appliedCoupons
            }
        });
    }

    const BackToHome = (flag) => {
        localStorage.removeItem('EventViewFlag');
        localStorage.removeItem('EventDetailsId');
        localStorage.removeItem('EventId');
        localStorage.removeItem('EventType');
        const CountryCode = localStorage.getItem('CountryCode');
        const CountryName = localStorage.getItem('Country');
        navigate('/' + CountryCode + '/' + CountryName);
    }

    const BackToEventDetails = (e) => {
        // navigate('/event_details', { state: { event_id: EventId } })
        navigate("/e/" + (EventRedirectionName).replace(/\s/g, '_'));
    }
    // console.log(TotalPrice);

    const sumKey = (AllTickets, key) => {
        return AllTickets.reduce((sum, item) => sum + Number(item[key] || 0), 0);
    };
    //-----------------------
    // const handleRemovePreviousAppliedCoupon = (TotalPrice, AllTickets) => {
    //     setCouponCode('');
    //     // console.log(appliedCoupons);
    //     let oneTimeApplied = false;
    //     const final_amt = isNaN(parseFloat(TotalPrice)) ? 0.00 : parseFloat(TotalPrice);
    //     let totalAmount = 0;
    //     let totalAmount1 = 0;
    //     let count = 0;

    //     const totalTicketsCount = sumKey(AllTickets, "count");
    //     // console.log(totalTicketsCount);

    //     AllTickets.forEach(element => {
    //         // console.log(element);
    //         const SingleTicketId = element["id"];
    //         // console.log(appliedCoupons);
    //         appliedCoupons.forEach(item => {

    //             count = parseFloat(totalTicketsCount); 

    //             const CouponTicketIds = item.ticket_details.split(',');
    //                 if (CouponTicketIds.includes(String(SingleTicketId)) && element["count"] != 0 ) { 
    //                     if (count <= item.pending_coupon_count) {
    //                         //------- Discount Type Percentage
    //                         if(SingleTicketId == SingleTicketId1){
    //                             if(item.discount_amt_per_type === 1){
    //                                 count += 1;
    //                                 // -------- One time use / Multiple time use
    //                                 totalAmount += ((parseFloat(element["ticket_price"]) * item.discount_percentage)/100) * element["count"];  
    //                                 element.appliedCouponAmount = totalAmount;
    //                                 element.appliedCouponCode = item.discount_code;
    //                                 element.appliedCouponId = item.id;
    //                                 element.appliedCouponTicketCount = element["count"]; 
    //                                 item.coupon_count = count;

    //                             }else{  //------- Discount Type Amount

    //                                 count += 1;
    //                                 // -------- One time use / Multiple time use
    //                                 totalAmount += (item.discount_amount * element["count"] ); 
    //                                 element.appliedCouponAmount = totalAmount;
    //                                 element.appliedCouponCode = item.discount_code;
    //                                 element.appliedCouponId = item.id;
    //                                 element.appliedCouponTicketCount = element["count"]; 
    //                                 item.coupon_count = count;
    //                             }
    //                         }
    //                     }else{
    //                         if(SingleTicketId == SingleTicketId1){
    //                             toast.error("This coupon code is out of stock.");
    //                         }
    //                     }
    //                 } else {
    //                     totalAmount += 0;

    //                     if (element["appliedCouponAmount"] && element["appliedCouponId"] === item.id) {
    //                         delete element["appliedCouponAmount"];
    //                         delete element["appliedCouponCode"];
    //                         delete element["appliedCouponId"];
    //                         delete element["appliedCouponTicketCount"];

    //                         const allWithoutCoupon = AllTickets.every(ticket => !("appliedCouponId" in ticket));
    //                         // console.log(allWithoutCoupon);
    //                         if (allWithoutCoupon) {
    //                             Coupons.forEach(element => {
    //                                 HandleRemoveCouponAmount(element)
    //                                 setAppliedCoupons(prevCoupons => prevCoupons.filter(item => item.id !== element.id));
    //                             });
    //                         }
    //                     }
    //                 }
    //             // new added for applied amount in coupon data
    //             totalAmount1 = AllTickets.reduce(
    //                 (sum, item1) => sum + (Number(item1.appliedCouponAmount) || 0),
    //                 0
    //             );

    //             NewCouponData.applied_amount = totalAmount1;
    //         })
    //     })
    //     const newFinalTot = (final_amt - totalAmount1);
    //     setFinalTotalPrice(newFinalTot.toFixed(2));
    // }
    // console.log(AllTickets);
    const handleRemovePreviousAppliedCoupon = (TotalPrice, AllTickets) => {

        const final_amt = isNaN(parseFloat(TotalPrice)) ? 0 : parseFloat(TotalPrice);
        let totalCouponDiscount = 0;

        // 🔹 Reset previous coupon data from tickets
        AllTickets.forEach(ticket => {
            delete ticket.appliedCouponAmount;
            delete ticket.appliedCouponCode;
            delete ticket.appliedCouponId;
            delete ticket.appliedCouponTicketCount;
        });

        // 🔹 Apply coupons
        appliedCoupons.forEach(coupon => {
            const couponTicketIds = coupon.ticket_details
                .split(',')
                .map(id => Number(id));

            let remainingCouponUses = coupon.pending_coupon_count;
            // console.log(remainingCouponUses);
            AllTickets.forEach(ticket => {
                if (
                    remainingCouponUses <= 0 ||
                    ticket.count <= 0 ||
                    !couponTicketIds.includes(ticket.id)
                ) {
                    return;
                }

                // How many tickets can this coupon apply to
                const applicableCount = Math.min(ticket.count, remainingCouponUses);
                let discountPerTicket = 0;

                // 🔸 Percentage discount
                if (coupon.discount_amt_per_type === 1) {
                    discountPerTicket = (Number(ticket.ticket_price) * Number(coupon.discount_percentage)) / 100;
                }
                // 🔸 Flat amount discount
                else {
                    discountPerTicket = Number(coupon.discount_amount);
                }

                const ticketDiscount = discountPerTicket * applicableCount;
                // 🔹 Add to total discount
                totalCouponDiscount += ticketDiscount;

                // 🔹 Save coupon data on ticket
                ticket.appliedCouponAmount = ticketDiscount;
                ticket.appliedCouponCode = coupon.discount_code;
                ticket.appliedCouponId = coupon.id;
                ticket.appliedCouponTicketCount = applicableCount;

                remainingCouponUses -= applicableCount;
            });
        });

        // 🔹 Update coupon applied amount
        NewCouponData.applied_amount = totalCouponDiscount;
        // 🔹 Final price after coupon
        const newFinalTotal = final_amt - totalCouponDiscount;
        // 🔹 Update React state
        setFinalTotalPrice(newFinalTotal.toFixed(2));
    }

    return (
        <>
            <AppliedCouponAlert AppliedCouponPopup={AppliedCouponPopup} DisplayCouponCode={DisplayCouponCode} CouponDiscountPrice={CouponDiscountPrice}
                onClose={() => { setAppliedCouponPopup(false); setDisplayCouponCode(""); setCouponDiscountPrice(0) }}
                onConfirm={() => {
                    setCouponDiscountPrice(0);
                    setDisplayCouponCode("");
                    setAppliedCouponPopup(false);
                }}
            />

            {PaymentFailurePopup === true ?

                <div className="modal is-visible" data-animation="slideInUp">
                    <div className="modal-dialog quickview__main--wrapper">
                        <div className="quickview__inner">
                            <div className="row">
                                <div className="login__section">
                                    <div className="login__section--inner">
                                        <div className="p-5">
                                            <div className="account__login--header mb-25 text-center">

                                                <img src={failedImg} alt="" style={{ height: 150 }} />
                                                <p className='h3 my-3'>Payment failed</p>
                                                <p className="account__login--header__desc mb-0">Unfortunately sonthing went wrong.</p>
                                                <p className="account__login--header__desc mb-2">Please try again...</p>

                                            </div>
                                            <div className="d-flex gap-4">
                                                <button className="account__login--btn secondary__btn mt-2" onClick={(e) => { setPaymentFailurePopup(false); navigate('/register_now/' + EventId); }} >Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                :
                ''
            }

            {LoaderFlag ? <Loader /> : null}
            <ToastContainer theme="colored" />
            <HeaderSecond Login={Login} setLogin={setLogin} />
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        SECURE CHECKOUT
                                    </h1>
                                    {/* <ul className="breadcrumb__content--menu d-flex">

                                        <li className="breadcrumb__content--menu__items" onClick={(e) => BackToHome('home')}>
                                            <div className="text-white">
                                                Home
                                            </div>
                                        </li>

                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">Register Now</span>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8">
                                <div className="main checkout__mian">

                                    <div className="checkout__content--step section__shipping--address ">
                                        <div className="mb-5">
                                            <div className="section__header checkout__section--header d-flex align-items-center mb-4">

                                                <div className="row w-100">
                                                    <div className="col-sm-10">
                                                        <h2 className="section__header--title h3 mb-3">{EventData ? EventData.display_name : ''}</h2>
                                                        {AllTickets && AllTickets.length > 0 ?
                                                            <p>{EventData.start_date} | {EventData.city_name}</p>
                                                            : null}
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="event-visibility hand_cursor" style={{ width: "fit-content", float: "right" }} onClick={(e) => BackToEventDetails(e)}>
                                                            <div className="visibility gap-1 ">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    height={20}
                                                                    viewBox="0 -960 960 960"
                                                                    width={20}
                                                                >
                                                                    <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
                                                                </svg>
                                                                Back
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>

                                        </div>
                                    </div>
                                    {/* {console.log(AllTickets)} Single category allowed */}
                                    {EventRegiStatus === 1 ?
                                        <div className="select-event mb-2">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <p className="text-right text-danger">Only single ticket selection is allowed.</p>
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
{/* {console.log(AllTickets)} */}
                                    <div className="select-event mb-5">
                                        <div className="row">
                                            {AllTickets && AllTickets.length > 0 ? (
                                                AllTickets.map((item, index) => (

                                                    <div className="safe-checkout mb-4" key={index}>

<div className="my-booking">
    <div className="row coupon mb-4" style={{ height: "auto", display: "flex", justifyContent: "center", padding: "0px 25px" }}>
        <div className="col-12 d-block">
            <div className="row h-100">
                {/* CENTER CONTENT */}
                <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 col-xxl-10 d-flex flex-column justify-content-around py-5">
                    <div className="ticket-header-wrap py-3">
                        <div className="ticket-header-title">
                            <h3 className="section__header--title h3 text__secondary d-flex gap-2"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm0-160q17 0 28.5-11.5T520-480q0-17-11.5-28.5T480-520q-17 0-28.5 11.5T440-480q0 17 11.5 28.5T480-440Zm0-160q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm320 440H160q-33 0-56.5-23.5T80-240v-160q33 0 56.5-23.5T160-480q0-33-23.5-56.5T80-560v-160q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v160q-33 0-56.5 23.5T800-480q0 33 23.5 56.5T880-400v160q0 33-23.5 56.5T800-160Zm0-80v-102q-37-22-58.5-58.5T720-480q0-43 21.5-79.5T800-618v-102H160v102q37 22 58.5 58.5T240-480q0 43-21.5 79.5T160-342v102h640ZM480-480Z" /></svg> {item.display_ticket_name}</h3>

                            {item.ticket_sale_end_date !== "" ?
                                <small className="" > <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" ><path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z" /></svg> {"Closing on : " + item.ticket_sale_end_date}</small>
                                : null}
                        </div>
                        <div className="d-flex justify-content-end align-items-center flex-column">

                            {
                                item.ticket_status === 1 ?
                                    item.show_early_bird === 1 ?
                                        <div className="text-left">
                                            <div className="ticket-prices d-flex justify-content-end">
                                                <div className="original-price ticket-amt">
                                                    ₹{item.ticket_price}
                                                </div>
                                                <div className="discount-price ticket-amt">
                                                    ₹{parseFloat(item.discount_ticket_price).toFixed(2)}
                                                </div>
                                                <div className="total-discount">
                                                    ₹{parseFloat(item.total_discount).toFixed(2)}{" "}OFF
                                                </div>
                                            </div>
                                        </div>

                                        :
                                        <div className="text-left ticket-amt"> ₹{item.ticket_price}</div>
                                    :
                                    <div className="text-left"><span className="total-discount">Free</span></div>
                            }

                            {item.show_early_bird == 1 ?
                            <small style={{marginTop:"5px", color:"#6a6a6a"}}>Early Bird discount ending on - {new Date(item.end_time * 1000).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            })}</small>
                        : ""}
                        </div>
                        
                    </div>
                    
                    {item.ticket_description !== "" ?
                        <>
                            <hr />
                            <div className="d-flex flex-column gap-3">
                                <p className="header-text text-left" style={{ whiteSpace: 'pre-line' }}>{item.ticket_description}</p>
                            </div>
                        </>
                    : null}

                    <hr />

                    {/* PRICE */}
                    <div className="row py-2 mx-1">
                        <div className="col-sm-8 p-0">
                            <div className="header-text d-flex gap-2 text-left">
                                <p className="m-0" style={{ display: "inline" }}><strong>Add-Ons :</strong></p>

                                <p className="m-0"
                                    style={{
                                        display: "inline",
                                        marginLeft: 5,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%"
                                    }}
                                > <p style={{ textWrap: 'wrap' }}>
                                        {item.event_scan_categories_status === 1 && item.event_scan_categories ?
                                            item.event_scan_categories : "N/A"}</p></p>
                            </div>
                        </div>
                        <div className="col-sm-4 p-0">
                            <div className="text-right ticket-max-error">
                                <p className="text-danger">{item.Error ? item.Error : ""}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT QR */}
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-2 d-flex flex-column align-items-center justify-content-center gap-3 py-4 booking-qr-border-right">

                     {item.show_early_bird == 1 ?
                            <span
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "7px",
                                padding: "5px 10px",
                                background: "linear-gradient(135deg, #ffc107 0%, #ffc100 100%)",
                                color: "#fff",
                                fontSize: "16px",
                                fontWeight: 600,
                                lineHeight: 1,
                                borderRadius: "0px 0px 0px 10px",
                                whiteSpace: "nowrap",
                                boxShadow: "0 2px 5px rgba(255,159,28,0.25)",
                                position: "absolute",
                                top: "0px",
                                right: "0px",
                            }}
                            >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="#ffffff"
                            style={{ fill: "#ffffff" }}>
                                <path d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z" />
                            </svg>

                            <span style={{color:"#ffffff"}}>Early Bird</span>
                            </span>

                        : ""}

                    {item.count < item.min_booking ?
                        <p
                            className="blog__content--btn primary__btn m-0"
                            onClick={() => {
                                TicketCount(index, 'add');
                                handleOnfocus();
                            }}
                            style={{cursor:'pointer'}}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                                <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                            </svg>
                            Add
                        </p>
                    :
                        <div className="d-flex align-items-center blog__content--btn primary__btn m-0 plus-minus-btn">
                            <p className=" m-0 minus fs-3" onClick={() => TicketCount(index, 'minus')}>-</p>
                            <input className="count" type="text" value={item.count} readOnly />
                            <p className=" m-0 plus fs-3" onClick={() => TicketCount(index, 'plus')}>+</p>
                        </div>
                    }

                    {item.RemainingTickets !== 0 ?
                        <p className="blog__content--btn primary__btn  badge-light m-0" >{item.RemainingTickets + " Left"}</p>
                    : null} 

                    <div className="text-center ticket-max-error-mbl">
                        <p className="text-danger">{item.Error ? item.Error : ""}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

{/* ------------------------------- Old code -------------------------- */}
{/* <div className="card"
    style={{
        backgroundColor:
            (item.event_id === 56 || item.event_id === 74) &&
                (item.id === 174 || item.id === 184 || item.id === 176 || item.id === 186)
                ? "#bcd6ff"
                : "",
    }}>
    <div className="row">
        <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9 col-xxl-10">
            <h4 className="header-text text-left">{item.display_ticket_name}</h4>

            {
                item.event_scan_categories_status === 1 && item.event_scan_categories ?
                    <>
                        <div className="header-text text-left">
                            <p style={{ color: 'red', display: "inline" }}>Add-Ons :</p>
                            <p
                                style={{
                                    display: "inline",
                                    marginLeft: 5,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%"
                                }}
                            > <strong style={{ textWrap: 'wrap' }}>{item.event_scan_categories}</strong></p>
                        </div>
                        <br />
                    </>
                    : null
            }

            {item.ticket_description !== "" ?
                <p className="header-text text-left" style={{ whiteSpace: 'pre-line' }}>{item.ticket_description}</p>
                : null}
            {
                item.ticket_status === 1 ?
                    item.show_early_bird === 1 ?
                        <div className="text-left">
                            <div className="ticket-prices">
                                <div className="original-price">
                                    ₹{item.ticket_price}
                                </div>
                                <div className="discount-price">
                                    ₹{parseFloat(item.discount_ticket_price).toFixed(2)}
                                </div>
                                <div className="total-discount">
                                    ₹{parseFloat(item.total_discount).toFixed(2)}{" "}OFF
                                </div>
                            </div>
                        </div>
                        :
                        <div className="text-left"> ₹{item.ticket_price}</div>
                    :
                    <div className="text-left"><span className="total-discount">Free</span></div>
            }

            <div className='text-left'>
                {item.ticket_sale_end_date !== "" ?
                    <small className="" > <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" ><path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z" /></svg> {"Closing on : " + item.ticket_sale_end_date}</small>
                    : null}
            </div>


            <p className="text-right text-danger">{item.Error ? item.Error : ""}</p>
        </div>
        {item.count < item.min_booking ?
            <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 col-xxl-2 custom-ticket-btns cursor-pointer" >
                <p
                    className="blog__content--btn primary__btn m-0"
                    onClick={() => {
                        TicketCount(index, 'add');
                        handleOnfocus();
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                        <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                    </svg>
                    Add
                </p>
                {item.RemainingTickets !== 0 ?
                    <p className="blog__content--btn primary__btn  badge-light m-0" >{item.RemainingTickets + "5 Left"}</p>
                : null} 
            </div>
            :
            <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 col-xxl-2 custom-ticket-btns">
                <div className="d-flex align-items-center blog__content--btn primary__btn m-0 plus-minus-btn">
                    <p className=" m-0 minus fs-3" onClick={() => TicketCount(index, 'minus')}>-</p>
                    <input className="count" type="text" value={item.count} readOnly />
                    <p className=" m-0 plus fs-3" onClick={() => TicketCount(index, 'plus')}>+</p>
                </div>
                {item.RemainingTickets !== 0 ?
                    <p className="blog__content--btn primary__btn  badge-light m-0" >{item.RemainingTickets + " Left"}</p>
                    : null}
            </div>
        }
    </div>

    <div className='row d-flex align-items-center'>
        <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9 col-xxl-10 text-left">

        </div>
        <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 col-xxl-2 text-center">

        </div>
    </div>
</div> */}
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No registration available</p>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 safe-checkout-summary" id="navigateHere">
                                {parseInt(TotalAttendee) !== 0 ?
                                    <>
                                        <aside className="checkout__sidebar sidebar border-radius-10 position-relative top-0" >
                                            <h2 className="section__header--title text-center h3 mb-5">SUMMARY</h2>
                                            <div className="card p-4 mb-4">
                                                <div className="row my-3">
                                                    <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10">

                                                        <p className="m-0">Price ({TotalAttendee} Registration)</p>
                                                    </div>

                                                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 d-flex align-items-center justify-content-end">
                                                        {/* <p className="m-0">₹{parseFloat(TotalPrice).toFixed(2)}</p> */}
                                                        <p className="m-0">₹{parseFloat(TotalPrice).toFixed(2)}</p>
                                                    </div>

                                                    {/* APPLIED COUPONS */}
                                                    {/* {console.log(appliedCoupons)} */}
                                                    <div>
                                                        {appliedCoupons.map((item, index) => {
                                                            // Only render if applied_amount is greater than 0
                                                            // if (!item.applied_amount || parseFloat(item.applied_amount) === 0) return null;

                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <div className="row">
                                                                        <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
                                                                            <p className="m-0">{`${item.discount_code}`} (Coupon)</p>
                                                                        </div>
                                                                        <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 d-flex align-items-center justify-content-end">
                                                                            <p className="m-0">
                                                                                ₹{parseFloat(item.applied_amount).toFixed(2)}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            );
                                                        })}

                                                    </div>
                                                    {/*  */}
                                                </div>

                                                <div className="row my-3">
                                                    <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
                                                        <p className="h4 m-0">Total Amount</p> (<small>{EventData.prices_taxes_status == "Exclusive of Taxes" ? "Exclusive of taxes and other charges" : EventData.prices_taxes_status}</small>)
                                                        {/* <small>Prices are excluding Booking Fees</small> */}
                                                    </div>
                                                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 d-flex justify-content-end">
                                                        <p className="h4 m-0">₹{parseFloat(FinalTotalPrice).toFixed(2)}</p>
                                                    </div>
                                                </div>

                                            </div>

                                        </aside>
                                        {/* {console.log(CouponCode)} */}
                                        <aside>
                                            <div className="checkout__sidebar sidebar border-radius-10 mt-4 position-relative top-0">
                                                <div className="form-floating mt-3 mb-0 d-flex align-items-center">
                                                    <input type="text" className="form-control text-uppercase" placeholder="" maxLength={100} value={CouponCode} onChange={(e) => setCouponCode(e.target.value)} />
                                                    <label>Enter coupon code</label>
                                                    {CouponCode && RemoveCoupon === false ?
                                                        <div className="cursor-pointer" style={{ position: "absolute", right: "20px", color: "#ffffff", fontWeight: "500", backgroundColor: "#D26351", padding: "5px 20px", borderRadius: "50px" }} onClick={(e) => ApplyCouponCode(e)}>Apply</div>
                                                        : null}

                                                    {RemoveCoupon ? <div className="cursor-pointer" style={{ position: "absolute", right: "20px", color: "#ffffff", fontWeight: "500", backgroundColor: "#D26351", padding: "5px 20px", borderRadius: "50px" }} onClick={(e) => { handleRemoveCoupon(TempCouponData); setCouponCode(""); setRemoveCoupon(false); }}>Remove</div> : null}
                                                </div>
                                                {Coupons.length > 0 ?
                                                    <>
                                                        {Coupons.map((item, index) => (
                                                            <div className="my-4 coupon-code-ui">


                                                                <div className="coupon-card mb-4">
                                                                    <div className="coupon-left">
                                                                        <div className="coupon-title-wrap">
                                                                            <h4 className="coupon-title">
                                                                                {item.discount_amt_per_type === 1
                                                                                    ? `Flat ${item.discount_percentage}% off`
                                                                                    : `Flat ₹${item.discount_amount} off`}
                                                                            </h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className="coupon-content">
                                                                        <div className="coupon-content-wrap">
                                                                            <div className="coupon-left-copy">
                                                                                <h3 className="coupon-code-copy">{item.discount_code}</h3>

                                                                                <p className="coupon-desc-copy">
                                                                                    {item.discount_amt_per_type === 1
                                                                                        ? `Save ${item.discount_percentage}% on all transactions`
                                                                                        : `Save ₹${item.discount_amount} on all transactions`}
                                                                                </p>
                                                                            </div>
                                                                            <div className="coupon-right-copy">
                                                                                {isCouponApplied(item.id) ? (
                                                                                    <button
                                                                                        className="apply-btn-copy"
                                                                                        onClick={() => {
                                                                                            handleRemoveCoupon(item);
                                                                                            setCouponCode("");
                                                                                            setRemoveCoupon(false);
                                                                                        }}
                                                                                    >
                                                                                        Remove
                                                                                    </button>
                                                                                ) : (
                                                                                    <button
                                                                                        className="apply-btn-copy"
                                                                                        onClick={() => { handleApplyCoupon(item) }}
                                                                                    >
                                                                                        Apply
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            <hr />
                                                                            <small className="py-1">{item.description}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* <div className="card border-radius-10 mb-4">
                                                                    <div className="row p-4">
                                                                        <div className="col-3 col-sm-3 col-md-3 col-lg-12 col-xl-12 col-xxl-3 d-flex align-items-center justify-content-center">
                                                                            <img src={couponDiscount} alt="" style={{ width: "60px" }} />
                                                                        </div>
                                                                        <div className="col-9 col-sm-9 col-md-9 col-lg-12 col-xl-12 col-xxl-6">
                                                                            <h4 className="">{item.discount_code}</h4> 
                                                                            <small className="px-0 py-1 border-radius-5 dis-coupon-lable">
                                                                                {item.discount_amt_per_type === 1
                                                                                    ? `Save ${item.discount_percentage}% on this event`
                                                                                    : `Save ₹${item.discount_amount} on this event`}
                                                                            </small>
                                                                            <hr className="dotted-line" />
                                                                            <small className="px-0 py-1 border-radius-5 close-popup-icon">{item.description}</small>
                                                                        </div>
                                                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-3 d-flex justify-content-center align-items-center hand_cursor">
                                                                            {isCouponApplied(item.id) ? (
                                                                                <p className="apply-btn my-2" onClick={() => { handleRemoveCoupon(item); setCouponCode(""); setRemoveCoupon(false); }}>Remove</p>
                                                                            ) : (
                                                                                <p className="apply-btn my-2" onClick={() => { handleApplyCoupon(item) }}>Apply</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        ))}
                                                    </>
                                                    : null}
                                            </div>

                                            <div className='card p-3 py-1 mt-4 summary-proceed mobile-btn-ui' onClick={(e) => HandleContinue(e)}>
                                                <div className="row my-3">
                                                    <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-6 col-xxl-6">
                                                        <p className="h4 m-0"><svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22"><path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113Z" /></svg> {TotalAttendee}</p>
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-md-6 col-lg-8 col-xl-6 col-xxl-6 d-flex align-items-center justify-content-end">
                                                        <p className="h4 m-0">PROCEED <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" /></svg></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </aside>
                                    </>
                                    :
                                    <aside className="checkout__sidebar sidebar border-radius-10 text-center">
                                        <img src={NoItemAdded} alt="" style={{ width: 250 }} />
                                        <h4 className="pt-4">No Registration Added</h4>
                                    </aside>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </main >

        </>
    )
}

export default RegisterNow